import styled from "styled-components"
import media from "styled-media-query"
import { Link } from "gatsby"

export const Wrapper = styled.nav`
  ${media.lessThan("medium")`
       ul {
           a {
                margin-right: 18px;
                font-size: 18px;
           }
       }
       
    `}
`

export const Ul = styled.ul`
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  flex-wrap: wrap;
  list-style: none;
  margin-bottom: 32px;
  margin-top: 16px;
`

export const StyledLink = styled(Link)`
  color: var(--bg-white);
  display: flex;
  align-items: center;
  text-decoration: none;
  margin-right: 48px;
  font-size: 24px;
  font-weight: 700;

  &:hover {
    color: var(--mainDarker);
  }

  svg {
    width: 32px;
    height: 32px;
    margin-right: 12px;
  }
`

export const Li = styled.li`
  padding: 4px 0;
`
